import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import CommunicateWithIntelligence from './CommunicateWithIntelligence';
import PrivacyPolicy from './PrivacyPolicy';
import TermsAndConditions from './TermsAndConditions';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<CommunicateWithIntelligence />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsAndConditions />} />
      </Routes>
    </Router>
  );
}

export default App;
